import { render, staticRenderFns } from "./discount-goods-info.vue?vue&type=template&id=5cbb1d34&"
import script from "./discount-goods-info.vue?vue&type=script&lang=js&"
export * from "./discount-goods-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports